import React  from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import Globe from 'react-globe.gl';

// async fetch('./assets/ne_110m_admin_0_countries.geojson').then(res => {
//   console.log(res);
//   console.log(await res.json());
//  return res.json()
// } 
// ).then(countries => {
//   // world.polygonsData(countries.features.filter(d => d.properties.ISO_A2 !== 'AQ'));
//   console.log(countries)
  
// });
// let polygonsData
// async function getCountries() {
//   // console
//   let countries = await fetch(require('./assets/ne_110m_admin_0_countries.geojson'))
//   console.log(countries);
//   let json = await countries.json()
//   console.log(json);
//    polygonsData = json.features.filter(d => d.properties.ISO_A2 !== 'AQ')
//    console.log(polygonsData);
// }

// getCountries();



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
